import { tns } from 'tiny-slider/src/tiny-slider';

/**
 * Stats (data) carousel: one stat per slide, autoplaying with fade
 * ("gallery") transitions and tns' own dots.
 *
 * Timing: autoplayTimeout was tns' 5000ms default and speed 400ms. Grace asked
 * for "a touch faster" (TPN post-launch 11-04), so both are about 25% shorter.
 */
class StatsSlider {
	constructor(el, nav) {
		this.el = el;
		this.nav = nav;

		const statsSlider = tns({
			container: this.el,
			items: 1,
			slideBy: 1,
			mode: "gallery",
			autoplay: true,
			autoplayTimeout: 3750,
			autoplayButtonOutput: false,
			speed: 300,
			controls: false,
			nav: true,
			navPosition: "bottom",
			navContainer: this.nav
		});
		
	}
}

export default StatsSlider;